import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useScaffold } from "@Light/scaffold";
import { useNavigate } from "@Light/utils/context";
import clsx from "clsx";
import React from "react";

export type CancelConfirmedProps = {};

export const CancelConfirmed: React.FC<CancelConfirmedProps> = ({}) => {
  const navigate = useNavigate();
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const EnumeratedList = scaffold.page.enumeratedList;
  const InfoItem = scaffold.page.infoItem;
  return (
    <PageBody
      footer={
        <ButtonFooter>
          <Button
            onClick={() => {
              navigate("/account/service-details/");
            }}
          >
            Okay
          </Button>
        </ButtonFooter>
      }
    >
      <div className="flex flex-col gap-12 pt-8">
        <div className="flex flex-col gap-8">
          <div
            className={clsx(
              "font-medium text-2xl",
              scaffold.page.colors.text.primary,
            )}
          >
            We’ve received your request to cancel your electricity service
          </div>
          <div className={clsx(scaffold.page.colors.text.secondary)}>
            Here’s what happens next
          </div>
        </div>
        <EnumeratedList>
          <InfoItem title="Confirmation email">
            You will receive a confirmation email shortly
          </InfoItem>
          <InfoItem title="Final billing">
            A final bill will be sent to cover charges up to your cancellation
            date
          </InfoItem>
          <InfoItem title="Service termination">
            Your electricity service will end on the specified date. If you are
            switching to a new provider, work with them to avoid interruptions
          </InfoItem>
        </EnumeratedList>
      </div>
    </PageBody>
  );
};
